import type { FormRow } from "../types";

const TYPE_BADGE: Record<string, string> = {
  string: "abc",
  number: "1.0",
  integer: "1",
  boolean: "y/n",
  object: "{ }",
  array: "[ ]",
  enum: "▾",
  oneOf: "◇",
  anyOfTabs: "◇",
};

export const FieldCellRenderer = (props: { data?: FormRow }) => {
  const row = props.data;
  if (!row) return null;
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      <span style={{ fontWeight: 500 }}>{row.label}</span>
      <span
        style={{
          fontSize: 10,
          fontFamily: "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, Consolas, monospace",
          color: "#7a8db3",
          backgroundColor: "#0c1838",
          border: "1px solid #182a4a",
          padding: "1px 5px",
          borderRadius: 3,
        }}
      >
        {TYPE_BADGE[row.fieldType] ?? row.fieldType}
      </span>
      {row.required && (
        <span
          style={{ color: "#ff1744", fontWeight: 900, fontSize: 16, lineHeight: 1 }}
          title="Required"
        >
          *
        </span>
      )}
    </span>
  );
};
